import LayerPricing from "./LayerPricing";
import { Grid, Stack } from "@mui/material";
import Disabled from "components/common/Disabled";
import PeerReviewNotes from "components/common/PeerReviewNotes";
import TextNote from "components/common/TextNote";
import * as config from "config";
import { useState } from "react";

const ForestryLayerPricing = () => {
  const [showAdditionalInputs, setShowAdditionalInputs] = useState(false);
  return (
    <>
      <Grid item xs={12} lg={6}>
        <LayerPricing
          showAdditionalInputs={showAdditionalInputs}
          setShowAdditionalInputs={setShowAdditionalInputs}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <Stack
          direction={"column"}
          spacing={config.GRID_SPACING}
          justifyContent={"flex-start"}
        >
          <TextNote noteKey={"summary"} title={"Notes"} />
          <TextNote noteKey={"program"} title={"Risk/Program Notes"} />
          <TextNote noteKey={"riskControl"} title={"Risk Control Comments"} />
          <TextNote noteKey={"claims"} title={"Loss History"} />
          <TextNote noteKey={"modeling"} title={"Modeling Notes"} />
          <Disabled ifReadOnly>
            <PeerReviewNotes
              title={"Peer Review"}
              lg_width={12}
              growVertically={false}
            />
          </Disabled>
        </Stack>
      </Grid>
    </>
  );
};

export default ForestryLayerPricing;
